module.exports = __webpack_public_path__ + "img/floor.869f86c1.png";